<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { createRealEstateBrokerCommissionPresenter } from '../composables/realEstateBrokerCommissionPresenter';

defineProps({
  detail: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const { money } = createRealEstateBrokerCommissionPresenter(t);
</script>

<template>
  <LaisCard :title="t('REAL_ESTATE_BROKER_COMMISSION.PAYMENT.IDENTITY')">
    <dl class="grid gap-4 text-sm">
      <div>
        <dt class="text-lais-text-muted">
          {{ t('REAL_ESTATE_BROKER_COMMISSION.PAYMENT.FULL_NAME') }}
        </dt>
        <dd class="mt-1 font-semibold text-lais-text">
          {{
            detail?.corretor?.nome ||
            t('REAL_ESTATE_BROKER_COMMISSION.TABLE.NOT_INFORMED')
          }}
        </dd>
      </div>
      <div>
        <dt class="text-lais-text-muted">
          {{ t('REAL_ESTATE_BROKER_COMMISSION.PAYMENT.CPF') }}
        </dt>
        <dd class="mt-1 font-semibold text-lais-text">
          {{
            detail?.corretor?.cpf ||
            t('REAL_ESTATE_BROKER_COMMISSION.TABLE.NOT_INFORMED')
          }}
        </dd>
      </div>
      <div class="rounded-lais bg-lais-bg-soft p-4">
        <dt class="text-lais-text-muted">
          {{ t('REAL_ESTATE_BROKER_COMMISSION.PAYMENT.VALUE') }}
        </dt>
        <dd class="mt-1 font-redHatDisplay text-2xl font-bold text-lais-text">
          {{ money(detail?.valor_proprio) }}
        </dd>
      </div>
    </dl>
  </LaisCard>
</template>
